App.prototype.setBoxedLayout = function () {
    $('.layout-changer .set-boxed').addClass('active');
    $('.layout-changer .set-horizontal').removeClass('active');
    $('.products-holder .product-column')
        .removeClass('col-sm-24')
        .removeClass('col-24')
        .addClass('col-sm-6')
        .addClass('col-12');
    App.prototype.setCookie("layoutType", 'boxed', 30);
};

App.prototype.setHorizontalLayout = function () {
    $('.layout-changer .set-boxed').removeClass('active');
    $('.layout-changer .set-horizontal').addClass('active');
    $('.products-holder .product-column')
        .addClass('col-sm-24')
        .addClass('col-24')
        .removeClass('col-sm-6')
        .removeClass('col-12');
    App.prototype.setCookie("layoutType", 'horizontal', 30);
};

$('.layout-changer .set-boxed').click(function () {
    if ($('.load-more-trigger').length){
        App.prototype.setCookie("layoutType", 'boxed', 30);
        location.reload();
    }else{
        App.prototype.setBoxedLayout();
    }
});

$('.layout-changer .set-horizontal').click(function () {
    if ($('.load-more-trigger').length){
        App.prototype.setCookie("layoutType", 'horizontal', 30);
        location.reload();
    }else{
        App.prototype.setHorizontalLayout();
    }
});

if ($('.layout-changer').length){
    const layoutType = App.prototype.getCookie('layoutType') || 'horizontal';
    switch (layoutType){
        case "horizontal":
            $('.layout-changer .set-horizontal').addClass('active');
            break;
        case "boxed":
            $('.layout-changer .set-boxed').addClass('active');
            break;
    }
}
